import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface VeilleState {
  activated: boolean;
  timer: number;
  muted: boolean;
  screenSaver?: {
    activated: boolean;
    source: string;
    timeBeforeSwitch?: number;
  };
  slideShow?: {
    activated: boolean;
    sources: string[];
    timeBeforeSwitch?: number;
  };
  infoChannel?: {
    activated: boolean;
  };
}

export interface BotConfigState {
  defaultPosition: { lat: number; lng: number } | null;
  veille: VeilleState | null;
}

const initialState: BotConfigState = {
  defaultPosition: null,
  veille: null,
};

const botConfigSlice = createSlice({
  name: "BotConfig",
  initialState,
  reducers: {
    setBotConfig: (state, action: PayloadAction<BotConfigState>) => {
      state.defaultPosition = action.payload.defaultPosition;
      state.veille = action.payload.veille;
    },
  },
});

export const { setBotConfig } = botConfigSlice.actions;
export default botConfigSlice.reducer;
